export default {"src":"/_next/static/media/as-is-no-accidents.b64548bd.svg","height":63,"width":63,"blurWidth":0,"blurHeight":0};